import CafListagem from '@/screens/arrecadacao/caf/CafListagem'
import GpListagem from '@/screens/arrecadacao/gp/components/GpListagem'
import GdaListagem from '@/screens/arrecadacao/gda/components/GdaListagem'
import CaixaEntradaListagem from './listagem/CaixaEntradaListagem'
import CaixaEntradaListagemUc from './listagem/CaixaEntradaListagemUc'
import CaixaCadastrosEmAndamentoListagemRf from './listagem/CaixaCadastrosEmAndamentoListagemRf'
import CaixaCadastrosEmAndamentoListagemUc from './listagem/CaixaCadastrosEmAndamentoListagemUc'
import CaixaAguardandoRespostaIndeferimento from './listagem/CaixaAguardandoRespostaIndeferimento'
import CaixaEntradaOrdemServico from './listagem/CaixaEntradaOrdemServico'
import EmAnaliseListagem from './listagem/EmAnaliseListagem'
import EmAnaliseListagemUc from './listagem/EmAnaliseListagemUc'
import CaixaEmAnaliseOrdemServico from './listagem/CaixaEmAnaliseOrdemServico'
import CaixaDaeListagem from './listagem/CaixaDaeListagem'
import CaixaVistoriaRemota from './listagem/CaixaVistoriaRemota'
import CaixaDaeVtnListagem from './listagem/CaixaDaeVtnListagem'
import CaixaTitulosECertidoesListagem from './listagem/CaixaTitulosECertidoesListagem'
import CaixaOrdemServicoListagem from './listagem/CaixaOrdemServicoListagem'
import CaixaGestaoOSREURB from './listagem/CaixaGestaoOSREURB'
import CaixaProcessosArquivadosListagem from './listagem/CaixaProcessosArquivadosListagem'
import CaixaProcessosArquivadosListagemUc from './listagem/CaixaProcessosArquivadosListagemUc'
import AguardandoValidacaoListagem from './listagem/AguardandoValidacaoListagem'
import CaixaAguardandoAtualizacaoBaseListagem from './listagem/CaixaAguardandoAtualizacaoBaseListagem'
import CaixaArquivosListagem from './listagem/CaixaArquivosListagem'
import CaixaProcessosFinalizadosListagem from './listagem/CaixaProcessosFinalizadosListagem'
import CaixaInformacoesListagem from '@/components/CaixaInformacoesListagem'
import CaixaAssinaturasListagem from './listagem/CaixaAssinaturasListagem'
import CaixaAssinaturasLaudoListagem from './listagem/CaixaAssinaturasLaudoListagem'
import CaixaDocumentosListagem from './listagem/CaixaDocumentosListagem'
import CaixaAguardandoManifestacao from './listagem/CaixaAguardandoManifestacao'
import CaixaPublicacaoListagem from './listagem/CaixaPublicacaoListagem'
import CaixaEditalPublicacaoListagem from './listagem/CaixaEditalPublicacaoListagem'
import CaixaAguardandoOs from './listagem/CaixaAguardandoOs'
import CaixaAvocarProcessoListagem from './listagem/CaixaAvocarProcessoListagem'
import CaixaPortariaListagem from './listagem/CaixaPortariaListagem'
import CaixaEmEmissaoPortaria from './listagem/CaixaEmEmissaoPortaria'
import CaixaValidacaoPortaria from './listagem/CaixaValidacaoPortaria'
import CaixaCustasListagem from './listagem/CaixaCustasListagem'
import CaixaAguardandoEnvioCartorio from './listagem/CaixaAguardandoEnvioCartorio'
import CaixaAguardandoRegistroCartorio from './listagem/CaixaAguardandoRegistroCartorio'
import CaixaProcessosArquivadosListagemSetores from './listagem/CaixaProcessosArquivadosListagemSetores'
import AnalisarValidarProcessoDefault from './AnalisarValidarProcessoDefault'
import AnalisarValidarSubProcesso from './AnalisarValidarSubProcesso'
import Portaria from './Portaria'
import EmitirDae from './EmitirDae'
import GerarCustas from './GerarCustas'
import OrdemServico from './ordemServico/OrdemServico'
import ModelosListagem from './ModelosListagem'
import ResponderInformacao from './ResponderInformacoes'
import SolicitarArquivamento from './ordemServico/SolicitarArquivamento'
import EmissaoTituloCertidao from './EmissaoTituloCertidao'
import GestaoProcessoUsuario from './GestaoProcessoUsuario'
import CaixaAguardandoVtn from './listagem/CaixaAguardandoVtn'
import CalcularVtn from './CalcularVtn'
import InserirDadosCartorio from './InserirDadosCartorio'
import AnaliseProcesso from '@/screens/arrecadacao/components/AnaliseProcesso'
import GestaoConflito from '@/screens/ouvidoria/GestaoConflito.vue'
import ValidarShapeConflito from '@/screens/ouvidoria/ValidarShapeConflito.vue'
import VisualizarDAEs from './VisualizarDAEs'
import GpListagemPresidente from '@/screens/arrecadacao/gp/components/GpListagemPresidente'
import DiarioOficial from '@/screens/arrecadacao/gp/DiarioOficial'
import EncaminharPublicacao from '@/screens/arrecadacao/gp/components/diarioOficial/EncaminharPublicacao'
import InformarPublicacao from '@/screens/arrecadacao/gp/components/diarioOficial/InformarPublicacao'
import CaixaProcessosArquivadosListagemArrecadacao from '@/screens/arrecadacao/gda/components/CaixaProcessosArquivadosListagemArrecadacao'
import CertidaoListagem from './listagem/CertidaoListagem'
import ConfirmarDadosCertidao from './ConfirmarDadosCertidao'
import ConferenciaTituloCertidao from './ConferenciaTituloCertidao'
import Publicacao from '../analise/Publicacao'
import EmissaoMatricula from '../arrecadacao/gp/components/matricula/EmissaoMatricula'
import Visualizar from '@/screens/arrecadacao/cpat/Visualizar'
import Oficio from '@/screens/analise/oficio/Oficio'
import ConfirmarDadosOficio from '@/screens/analise/oficio/ConfirmarDados'
import EmissaoOficio from '@/screens/analise/oficio/EmissaoOficio'
import ProcessosAnalisadosListagem from './listagem/ProcessosAnalisadosListagem'
import CaixaCustasCertidaoListagem from './listagem/CaixaCustasCertidaoListagem'
import GerarCustasCertidao from './GerarCustasCertidao'
import ConfigurarVtn from './vtn/ConfigurarVtn'
import AdicionarPvtn from './vtn/AdicionarPvtn'
import cadastrarVtn from './vtn/cadastrarVtn'
import ConfigurarUpf from './vtn/ConfigurarUpf'
import GestaoVtn from './vtn/GestaoVtn'
import VisualizarVtn from './vtn/VisualizarVtn'
import EmitirDar from './vtn/EmitirDar'
import VisualizarDar from './vtn/VisualizarDar'
import RelatoriosVtnAp from './vtn/relatorios/Home'
import ConferirVTN from './vtn/ConferirVTN'
import CadastrarVtnRR from './vtn/CadastrarVtnRR'
import CadastrarVtnMA from './vtn/CadastrarVtnMA'
import CaixaProcessosAssinadosListagem from './listagem/CaixaProcessosAssinadosListagem'
import HomeLiberacao from '@/screens/central/cadastros/maranhao/liberacao/Home'
import CadastranteLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Cadastrante'
import InteressadoLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Interessado'
import ImovelLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Imovel'
import ResumoLiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/components/Resumo'
import LiberacaoClausula from '@/screens/central/cadastros/maranhao/liberacao/Cadastro'
import EscolhaTipoProcesso from '@/screens/central/liberacao/EscolhaTipoProcesso'
import CaixaCredenciados from './listagem/CaixaCredenciados.vue'
import CaixaSobrestado from './listagem/CaixaSobrestado.vue'
import EmissaoExtratoSentenca from '@/screens/analise/EmissaoExtratoSentenca'
import CaixaEntregaTitulo from './listagem/CaixaEntregaTitulo.vue'
import CaixaEmissaoTitulo from './listagem/CaixaEmissaoTitulo.vue'
import EmitirCertidaoArea from './EmitirCertidaoArea.vue'
import CadastroRf from '@/screens/analise/components/AppCadastroRf'
import AppCadastroUc from '@/screens/analise/components/AppCadastroUC'
import AguardandoValidacaoListagemUc from './listagem/AguardandoValidacaoListagemUc.vue'
import CaixaCadastrosPendentesGeo from '@/screens/analise/listagem/CaixaCadastrosPendentesGeo'
import GerarGeoCadastroPendente from '@/screens/analise/GerarGeoCadastroPendente.vue'
import CaixaRetificacao from './listagem/CaixaRetificacao.vue'
import CaixaBuscarProcessos from '@/screens/acompanharProcessos/CaixaBuscarProcessos.vue'
import CaixaSolicitacoes from '../acompanharProcessos/CaixaSolicitacoes.vue'
import CaixaSuspensao from './listagem/caixaSuspensao.vue'

export const items = [
  {
    path: 'CAIXA_ENTRADA',
    name: 'CAIXA_ENTRADA',
    component: CaixaEntradaListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_ENTRADA'
    }
  },
  {
    path: 'CAIXA_ENTRADA_UC',
    name: 'CAIXA_ENTRADA_UC',
    component: CaixaEntradaListagemUc,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_ENTRADA_UC'
    }
  },
  {
    path: 'CAIXA_ENTRADA_OS',
    name: 'CAIXA_ENTRADA_OS',
    component: CaixaEntradaOrdemServico,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_ENTRADA_OS'
    }
  },
  {
    path: 'AGUARDANDO_OS',
    name: 'AGUARDANDO_OS',
    component: CaixaAguardandoOs,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_OS'
    }
  },
  {
    path: 'arquivamento/:idProcesso',
    name: 'ARQUIVAMENTO',
    component: SolicitarArquivamento,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_OS'
    }
  },
  {
    path: 'EM_ANALISE',
    name: 'EM_ANALISE',
    component: EmAnaliseListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE'
    }
  },
  {
    path: 'EM_ANALISE_UC',
    name: 'EM_ANALISE_UC',
    component: EmAnaliseListagemUc,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE_UC'
    }
  },
  {
    path: 'EM_ANALISE_OS',
    name: 'EM_ANALISE_OS',
    component: CaixaEmAnaliseOrdemServico,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE_OS'
    }
  },
  {
    path: 'AGUARDANDO_VALIDACAO_ANALISE',
    name: 'AGUARDANDO_VALIDACAO_ANALISE',
    component: AguardandoValidacaoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_VALIDACAO_ANALISE'
    }
  },
  {
    path: 'AGUARDANDO_VALIDACAO_ANALISE_UC',
    name: 'AGUARDANDO_VALIDACAO_ANALISE_UC',
    component: AguardandoValidacaoListagemUc,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_VALIDACAO_ANALISE_UC'
    }
  },
  {
    path: 'AGUARDANDO_CALCULO_CUSTAS',
    name: 'AGUARDANDO_CALCULO_CUSTAS',
    component: CaixaCustasListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_CALCULO_CUSTAS'
    }
  },
  {
    path: 'DAE',
    name: 'DAE',
    component: CaixaDaeListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'DAE'
    }
  },
  {
    path: 'TITULO_CERTIDAO',
    name: 'TITULO_CERTIDAO',
    component: CaixaTitulosECertidoesListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'TITULO_CERTIDAO'
    }
  },
  {
    path: 'PROCESSO_ARQUIVADO',
    name: 'PROCESSO_ARQUIVADO',
    component: CaixaProcessosArquivadosListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'PROCESSO_ARQUIVADO'
    }
  },
  {
    path: 'FINALIZADOS_UC',
    name: 'FINALIZADOS_UC',
    component: CaixaProcessosArquivadosListagemUc,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'FINALIZADOS_UC'
    }
  },
  {
    path: 'PROCESSO_ARQUIVADO_GAC',
    name: 'PROCESSO_ARQUIVADO_GAC',
    component: CaixaProcessosArquivadosListagemSetores,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'PROCESSO_ARQUIVADO_GAC'
    }
  },
  {
    path: 'PROCESSO_ARQUIVADO_ARRECADACAO',
    name: 'PROCESSO_ARQUIVADO_ARRECADACAO',
    component: CaixaProcessosArquivadosListagemArrecadacao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'PROCESSO_ARQUIVADO_ARRECADACAO'
    }
  },
  {
    path: 'VISUALIZAR_PROCESSO',
    name: 'VISUALIZAR_PROCESSO',
    component: AnaliseProcesso,
    meta: {
      routeGroup: 'VISUALIZAR_PROCESSO'
    },
    props: {
      routeListagemName: 'PROCESSO_ARQUIVADO_ARRECADACAO',
      isVisualizar: true
    }
  },
  {
    path: 'ORDEM_SERVICO_REURB',
    name: 'ORDEM_SERVICO_REURB',
    component: CaixaGestaoOSREURB,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ORDEM_SERVICO_REURB'
    }
  },
  {
    path: 'ORDEM_SERVICO',
    name: 'ORDEM_SERVICO',
    component: CaixaOrdemServicoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ORDEM_SERVICO'
    }
  },
  {
    path: 'ARQUIVOS',
    name: 'ARQUIVOS',
    component: CaixaArquivosListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ARQUIVOS'
    }
  },
  {
    path: 'INFORMACAO_SOLICITADA',
    name: 'INFORMACAO_SOLICITADA',
    component: CaixaInformacoesListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'INFORMACAO_SOLICITADA'
    }
  },
  {
    codigo: 'ANALISAR',
    path: '/analisar/:idProcesso/:acaoCaixa',
    name: 'analise/analisar',
    component: AnalisarValidarProcessoDefault,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE'
    }
  },
  {
    codigo: 'oficio',
    path: '/analisar/emitirOficio',
    name: 'oficio',
    component: Oficio,
    props: true,
    redirect: { name: 'oficio/emissaoDRF' },
    meta: {
      isPublic: false,
      routeGroup: 'DRF_CAIXA_DE_ENTRADA'
    },
    children: [
      {
        path: 'emissao',
        name: 'oficio/emissaoDRF',
        component: EmissaoOficio,
        meta: {
          routeGroup: 'DRF_CAIXA_DE_ENTRADA'
        }
      },
      {
        path: '/conferencia-oficio/:idProcesso',
        name: 'conferencia-oficio',
        component: ConfirmarDadosOficio,
        props: true,
        meta: {
          routeGroup: 'DRF_CAIXA_DE_ENTRADA'
        }
      }
    ]
  },
  {
    codigo: 'ATUALIZAR_BASE',
    path: '/atualizarBase/:idProcesso/:acaoCaixa',
    name: 'analise/atualizarBase',
    component: AnalisarValidarProcessoDefault,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ATUALIZACAO_BASE'
    }
  },
  {
    codigo: 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO',
    path: '/documentos/uploadTermoContrato/:idProcesso/:acaoCaixa',
    name: 'analise/uploadTermoContrato',
    component: AnalisarValidarProcessoDefault,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'DOCUMENTOS'
    }
  },
  {
    codigo: 'ACUSAR_ENTREGA',
    path: '/documentos/acusarEntrega/:idProcesso/:acaoCaixa',
    name: 'analise/acusarEntrega',
    component: AnalisarValidarProcessoDefault,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'DOCUMENTOS'
    }
  },
  {
    codigo: 'VALIDAR',
    path: '/validar/:idProcesso/:acaoCaixa',
    name: 'analise/validar',
    component: AnalisarValidarProcessoDefault,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_VALIDACAO_ANALISE'
    }
  },
  {
    codigo: 'ANALISAR_VALIDAR_SUB',
    path: '/analisar-validar-sub/:idProcesso/:acaoCaixa',
    name: 'analise/analisar-validar-sub',
    component: AnalisarValidarSubProcesso,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE_OS'
    }
  },
  {
    codigo: 'CALCULAR_VTN',
    path: '/analise/calcular-vtn/:idProcesso/:protocolo',
    name: 'calcular-vtn',
    component: CalcularVtn,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_AGUARDANDO_VTN'
    }
  },
  {
    path: 'AVOCAR_PROCESSO',
    name: 'AVOCAR_PROCESSO',
    component: CaixaAvocarProcessoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AVOCAR_PROCESSO'
    }
  },
  {
    path: 'PUBLICACAO',
    name: 'PUBLICACAO',
    component: CaixaPublicacaoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'PUBLICACAO'
    }
  },
  {
    path: 'EDITAL_PUBLICACAO',
    name: 'EDITAL_PUBLICACAO',
    component: CaixaEditalPublicacaoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EDITAL_PUBLICACAO'
    }
  },
  {
    path: 'AGUARDANDO_MANIFESTACAO',
    name: 'AGUARDANDO_MANIFESTACAO',
    component: CaixaAguardandoManifestacao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_MANIFESTACAO'
    }
  },
  {
    path: 'PROCESSO_FINALIZADO',
    name: 'PROCESSO_FINALIZADO',
    component: CaixaProcessosFinalizadosListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'PROCESSO_FINALIZADO'
    }
  },
  {
    path: 'ASSINATURAS',
    name: 'ASSINATURAS',
    component: CaixaAssinaturasListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ASSINATURAS'
    }
  },
  {
    path: 'ANALISE_COLETIVA',
    name: 'ANALISE_COLETIVA',
    component: CaixaAssinaturasLaudoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ANALISE_COLETIVA'
    }
  },
  {
    path: 'CAIXA_PORTARIA',
    name: 'CAIXA_PORTARIA',
    component: CaixaPortariaListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_PORTARIA'
    }
  },
  {
    path: 'ATUALIZACAO_BASE',
    name: 'ATUALIZACAO_BASE',
    component: CaixaAguardandoAtualizacaoBaseListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ATUALIZACAO_BASE'
    }
  },
  {
    path: 'DOCUMENTOS',
    name: 'DOCUMENTOS',
    component: CaixaDocumentosListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'DOCUMENTOS'
    }
  },
  {
    codigo: 'ORDEM_SERVICO',
    path: '/ordem-servico',
    name: 'ordem-servico',
    component: OrdemServico,
    meta: {
      isPublic: false,
      routeGroup: 'ORDEM_SERVICO'
    }
  },
  {
    codigo: 'ORDEM_SERVICO_EDITAR',
    path: '/ordem-servico/editar/:numero',
    name: 'ordem-servico/editar',
    component: OrdemServico,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ORDEM_SERVICO'
    }
  },
  {
    codigo: 'CONTINUAR_EMISSAO_TITULO',
    path: '/continuar-emissao-titulo/:idProcesso/:tipo',
    name: 'continuar-emissao-titulo',
    component: EmissaoTituloCertidao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE'
    }
  },
  // CRIADO UM DO MA PARA QUANDO TIVER ANALISANDO FICAR VERDE A CAIXA DE EMISSAO_TITULO
  {
    codigo: 'CONTINUAR_EMISSAO_TITULO',
    path: '/continuar-emissao-titulo/:idProcesso/:tipo',
    name: 'continuar-emissao-titulo-ma',
    component: EmissaoTituloCertidao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_EMISSAO_TITULO'
    }
  },
  {
    codigo: 'EMISSAO_CUSTAS',
    path: '/emissao-custas/:idProcesso',
    name: 'analise/emissao-custas',
    component: GerarCustas,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_CALCULO_CUSTAS'
    }
  },
  {
    path: '/informacoes/:idSolicitacao',
    name: 'informacoes',
    component: ResponderInformacao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'INFORMACAO_SOLICITADA',
      menu: {
        routeGroup: 'INFORMACAO_SOLICITADA'
      }
    }
  },
  {
    path: '/dae/:idProcesso',
    name: 'financeiro/dae/CadastroDae',
    component: EmitirDae,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'DAE'
    }
  },
  {
    codigo: 'CONFERENCIA_CERTIDAO',
    path: '/conferencia-certidao/:idProcesso',
    name: 'conferencia-certidao',
    component: ConfirmarDadosCertidao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_VALIDACAO_ANALISE'
    }
  },
  {
    codigo: 'CONFERENCIA_TITULO_CERTIDAO',
    path: '/conferencia-titulo-certidao/:idProcesso',
    name: 'conferencia-titulo-certidao',
    component: ConferenciaTituloCertidao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE'
    }
  },
  // CRIADO UM DO MA PARA QUANDO TIVER ANALISANDO FICAR VERDE A CAIXA DE EMISSAO_TITULO
  {
    codigo: 'CONFERENCIA_TITULO_CERTIDAO',
    path: '/conferencia-titulo-certidao/:idProcesso',
    name: 'conferencia-titulo-certidao-ma',
    component: ConferenciaTituloCertidao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_EMISSAO_TITULO'
    }
  },
  {
    codigo: 'LISTAGEM_MODELOS_DESPACHO_NOTIFICACAO',
    path: '/listagemModelos',
    name: 'listagem-modelos-despacho-notificacao',
    component: ModelosListagem,
    props: true,
    meta: {
      isPublic: false
    }
  },
  {
    path: '/gestaoProcessoUsuario',
    name: 'gestao-processo-usuario',
    component: GestaoProcessoUsuario,
    props: true,
    meta: {
      isPublic: false
    }
  },
  {
    path: '/portaria/:idProcesso',
    name: 'portaria',
    component: Portaria,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_PORTARIA_EMISSAO',
      menu: {
        routeGroup: []
      }
    }
  },
  {
    path: '/portaria/:idProcesso/validar',
    name: 'portariaValidar',
    component: AnalisarValidarProcessoDefault,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_PORTARIA_VALIDACAO',
      menu: {
        routeGroup: []
      }
    }
  },
  {
    path: 'CAIXA_PORTARIA_EMISSAO',
    name: 'CAIXA_PORTARIA_EMISSAO',
    component: CaixaEmEmissaoPortaria,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_PORTARIA_EMISSAO'
    }
  },
  {
    path: 'CAIXA_PORTARIA_VALIDACAO',
    name: 'CAIXA_PORTARIA_VALIDACAO',
    component: CaixaValidacaoPortaria,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_PORTARIA_VALIDACAO'
    }
  },
  {
    path: 'LISTAGEM_PROCESSO_ORDEM_SERVICO/:numero',
    name: 'LISTAGEM_PROCESSO_ORDEM_SERVICO',
    component: OrdemServico,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ORDEM_SERVICO'
    }
  },
  {
    path: 'CAIXA_AGUARDANDO_VTN',
    name: 'CAIXA_AGUARDANDO_VTN',
    component: CaixaAguardandoVtn,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_AGUARDANDO_VTN'
    }
  },
  {
    path: 'DAE_VTN',
    name: 'DAE_VTN',
    component: CaixaDaeVtnListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'DAE_VTN'
    }
  },
  {
    path: 'CAIXA_PROCESSOS_OS',
    name: 'CAIXA_PROCESSOS_OS',
    component: OrdemServico,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ORDEM_SERVICO'
    }
  },
  {
    path: 'AGUARDANDO_ENVIO_CARTORIO',
    name: 'AGUARDANDO_ENVIO_CARTORIO',
    component: CaixaAguardandoEnvioCartorio,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_ENVIO_CARTORIO'
    }
  },
  {
    codigo: 'ENVIAR_DADOS_CARTORIO',
    path: 'ENVIAR_DADOS_CARTORIO/:idProcesso',
    name: 'ENVIAR_DADOS_CARTORIO',
    component: InserirDadosCartorio,
    props: true,
    meta: {
      isPublic: false
    }
  },
  {
    path: 'AGUARDANDO_ENVIO_REGISTRO_CARTORIO',
    name: 'AGUARDANDO_ENVIO_REGISTRO_CARTORIO',
    component: CaixaAguardandoRegistroCartorio,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_ENVIO_REGISTRO_CARTORIO'
    }
  },
  {
    path: 'CAF_CAIXA_DE_ENTRADA',
    name: 'CAF_CAIXA_DE_ENTRADA',
    component: CafListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAF_CAIXA_DE_ENTRADA'
    }
  },
  {
    path: 'GP_CAIXA_DE_ENTRADA',
    name: 'GP_CAIXA_DE_ENTRADA',
    component: GpListagemPresidente,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'GP_CAIXA_DE_ENTRADA'
    }
  },
  {
    path: 'visualizarProcesso',
    name: 'gp/visualizarProcesso',
    component: AnaliseProcesso,
    meta: {
      isPublic: false,
      routeGroup: 'GP_CAIXA_DE_ENTRADA'
    },
    props: { routeListagemName: 'GP_CAIXA_DE_ENTRADA', isVisualizar: true }
  },

  {
    path: 'GP_S1_CAIXA_DE_ENTRADA',
    name: 'GP_S1_CAIXA_DE_ENTRADA',
    component: GpListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
    }
  },

  {
    path: 'informarEnvio',
    name: 'gp/informarEnvio',
    component: DiarioOficial,
    redirect: { name: 'informarEnvio/encaminhar' },
    meta: {
      isPublic: false,
      routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
    },
    props: { routeListagemName: 'GP_S1_CAIXA_DE_ENTRADA', isVisualizar: true },
    children: [
      {
        path: 'visualizarProcesso',
        name: 'informarEnvio/visualizarProcesso',
        component: AnaliseProcesso,
        meta: {
          isPublic: false,
          routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
        },
        props: {
          routeListagemName: 'GP_S1_CAIXA_DE_ENTRADA',
          isVisualizar: true
        }
      },
      {
        path: 'encaminharPublicacao',
        name: 'informarEnvio/encaminhar',
        component: EncaminharPublicacao,
        meta: {
          isPublic: false,
          routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
        },
        props: {
          routeListagemName: 'GP_S1_CAIXA_DE_ENTRADA',
          isVisualizar: true
        }
      }
    ]
  },

  {
    path: 'confirmarEnvio',
    name: 'gp/confirmarEnvio',
    component: DiarioOficial,
    redirect: { name: 'diarioOficial/confirmar' },
    meta: {
      isPublic: false,
      routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
    },
    props: { routeListagemName: 'GP_S1_CAIXA_DE_ENTRADA', isVisualizar: true },
    children: [
      {
        path: 'visualizarProcesso',
        name: 'diarioOficial/visualizarProcesso',
        component: AnaliseProcesso,
        meta: {
          isPublic: false,
          routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
        },
        props: {
          routeListagemName: 'GP_S1_CAIXA_DE_ENTRADA',
          isVisualizar: true
        }
      },
      {
        path: 'confirmarPublicacao',
        name: 'diarioOficial/confirmar',
        component: InformarPublicacao,
        meta: {
          routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
        },
        props: {
          routeListagemName: 'GP_S1_CAIXA_DE_ENTRADA',
          isVisualizar: true
        }
      }
    ]
  },
  {
    path: 'minutaMatricula',
    name: 'gp/minutaMatricula',
    component: Publicacao,
    meta: {
      isPublic: false,
      routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
    },
    props: {
      routeListagemName: 'GP_S1_CAIXA_DE_ENTRADA',
      isVisualizar: true
    },
    children: [
      {
        path: 'informarDados',
        name: 'oficiomatricula/informarDados',
        component: EmissaoMatricula,
        meta: {
          routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
        }
      },
      {
        path: 'analiseProcesso',
        name: 'oficiomatricula/analise',
        component: AnaliseProcesso,
        props: {
          isVisualizar: true
        },
        meta: {
          routeGroup: 'GP_S1_CAIXA_DE_ENTRADA'
        }
      },
      {
        path: '*',
        redirect: { name: 'matricula/informarDados' }
      }
    ]
  },
  {
    path: 'GDA_CAIXA_DE_ENTRADA',
    name: 'GDA_CAIXA_DE_ENTRADA',
    component: GdaListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'GDA_CAIXA_DE_ENTRADA'
    }
  },
  {
    path: 'caf/analiseProcesso',
    name: 'CAF/ANALISEPROCESSO',
    component: AnaliseProcesso,
    meta: {
      isPublic: false,
      routeGroup: 'CAF_CAIXA_DE_ENTRADA'
    },
    props: { routeListagemName: 'CAF_CAIXA_DE_ENTRADA' }
  },
  {
    path: 'gda/analiseProcesso',
    name: 'GDA/ANALISEPROCESSO',
    component: AnaliseProcesso,
    meta: {
      isPublic: false,
      routeGroup: 'GDA_CAIXA_DE_ENTRADA'
    },
    props: { routeListagemName: 'GDA_CAIXA_DE_ENTRADA' }
  },
  {
    path: 'VISUALIZAR_DAES/:idProcesso',
    name: 'VISUALIZAR_DAES',
    component: VisualizarDAEs,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'DAE_VTN'
    }
  },
  {
    path: '/LISTAGEM_CERTIDAO/:idProcesso',
    name: 'LISTAGEM_CERTIDAO',
    component: CertidaoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'LISTAGEM_CERTIDAO'
    }
  },
  {
    path: '/CONFIRMAR_DADOS/:idProcesso',
    name: 'CONFIRMAR_DADOS',
    component: ConfirmarDadosCertidao,
    props: route => ({
      isValidacao: false,
      idProcesso: route.params.idProcesso
    }),
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE'
    }
  },
  {
    path: 'conversa',
    name: 'analise/cartorio/conversa',
    component: Visualizar,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE'
    }
  },
  {
    codigo: 'ELABORAR_EDITAL',
    path: '/ELABORAR_EDITAL/:idProcesso/:acaoCaixa',
    name: 'ELABORAR_EDITAL',
    component: AnalisarValidarProcessoDefault,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EDITAL_PUBLICACAO'
    }
  },
  {
    path: 'PROCESSOS_ANALISADOS',
    name: 'PROCESSOS_ANALISADOS',
    component: ProcessosAnalisadosListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'PROCESSOS_ANALISADOS'
    }
  },
  {
    path: 'EMISSAO_CUSTAS_CERTIDAO',
    name: 'EMISSAO_CUSTAS_CERTIDAO',
    component: CaixaCustasCertidaoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EMISSAO_CUSTAS_CERTIDAO'
    }
  },
  {
    codigo: 'EMISSAO_CUSTAS_CERTIDAO',
    path: '/emissao-custas-certidao/:idProcesso',
    name: 'analise/emissao-custas-certidao',
    component: GerarCustasCertidao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'AGUARDANDO_CALCULO_CUSTAS'
    }
  },
  {
    path: 'CONFIGURACAO_VTN',
    name: 'CONFIGURACAO_VTN',
    component: ConfigurarVtn,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CONFIGURACAO_VTN'
    }
  },
  {
    path: 'pvtn/adicionar',
    name: 'pvtn/adicionar',
    component: AdicionarPvtn,
    props: true,
    meta: {
      routeGroup: 'CONFIGURACAO_VTN'
    }
  },
  {
    path: 'calcular-vtn-ap',
    name: 'calcular-vtn-ap',
    component: cadastrarVtn,
    props: true,
    meta: {
      routeGroup: 'CAIXA_AGUARDANDO_VTN'
    }
  },
  {
    path: 'calcular-vtn-ma/:idProcesso/:protocolo',
    name: 'calcular-vtn-ma',
    component: CadastrarVtnMA,
    props: true,
    meta: {
      routeGroup: 'CAIXA_ENTRADA'
    }
  },
  {
    path: 'visualizar-vtn',
    name: 'visualizar-vtn',
    component: VisualizarVtn,
    props: true,
    meta: {
      routeGroup: 'GESTAO_VTN'
    }
  },
  {
    path: 'gerenciar-vtn',
    name: 'gerenciar-vtn',
    component: VisualizarVtn,
    props: true,
    meta: {
      routeGroup: 'GESTAO_VTN'
    }
  },
  {
    path: 'CONFIGURACAO_UPF',
    name: 'CONFIGURACAO_UPF',
    component: ConfigurarUpf,
    props: true,
    meta: {
      routeGroup: 'CONFIGURACAO_UPF'
    }
  },
  {
    path: 'GESTAO_VTN',
    name: 'GESTAO_VTN',
    component: GestaoVtn,
    props: true,
    meta: {
      routeGroup: 'GESTAO_VTN'
    }
  },
  {
    path: 'EMITIR_DAR',
    name: 'EMITIR_DAR',
    component: EmitirDar,
    props: true,
    meta: {
      routeGroup: 'GESTAO_VTN'
    }
  },
  {
    path: 'CONFERIR_VTN',
    name: 'CONFERIR_VTN',
    component: ConferirVTN,
    props: true,
    meta: {
      routeGroup: 'AGUARDANDO_VALIDACAO_ANALISE'
    }
  },
  {
    path: 'VISUALIZAR_DAR',
    name: 'VISUALIZAR_DAR',
    component: VisualizarDar,
    props: true,
    meta: {
      routeGroup: 'GESTAO_VTN'
    }
  },
  {
    path: 'RELATORIOS_VTN',
    name: 'RELATORIOS_VTN',
    component: RelatoriosVtnAp,
    props: true,
    meta: {
      routeGroup: 'RELATORIOS_VTN'
    }
  },
  {
    path: 'calcular-vtn-rr',
    name: 'calcular-vtn-rr',
    component: CadastrarVtnRR,
    props: true,
    meta: {
      routeGroup: 'CAIXA_EM_ANALISE'
    }
  },
  {
    path: 'AGUARDANDO_INDEFERIMENTO',
    name: 'AGUARDANDO_INDEFERIMENTO',
    component: CaixaAguardandoRespostaIndeferimento,
    props: true,
    meta: {
      routeGroup: 'AGUARDANDO_INDEFERIMENTO'
    }
  },
  {
    path: 'PROCESSOS_ASSINADOS',
    name: 'PROCESSOS_ASSINADOS',
    component: CaixaProcessosAssinadosListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'PROCESSOS_ASSINADOS'
    }
  },
  {
    path: 'liberacao-clausula',
    name: 'analise/liberacao-clausula',
    component: HomeLiberacao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'liberacao-clausula'
    }
  },
  {
    path: 'cadastro/escolher-tipo-processo',
    name: 'analise/cadastro/escolher-tipo-processo',
    component: EscolhaTipoProcesso,
    meta: {
      menu: 'analise/liberacao-clausula',
      routeGroup: 'liberacao-clausula'
    }
  },
  {
    path: 'cadastro/liberacao-clausula/:idCadastro',
    name: 'analise/liberacao-clausula',
    component: LiberacaoClausula,
    props: true,
    redirect: { name: 'liberacao-clausula/cadastrante' },
    children: [
      {
        path: 'cadastrante',
        name: 'analise/liberacao-clausula/cadastrante',
        component: CadastranteLiberacaoClausula,
        meta: {
          routeGroup: 'liberacao-clausula'
        }
      },
      {
        path: 'interessado',
        name: 'analise/liberacao-clausula/interessado',
        component: InteressadoLiberacaoClausula,
        meta: {
          routeGroup: 'liberacao-clausula'
        }
      },
      {
        path: 'imovel',
        name: 'analise/liberacao-clausula/imovel',
        component: ImovelLiberacaoClausula,
        meta: {
          routeGroup: 'liberacao-clausula'
        }
      },
      {
        path: 'resumo',
        name: 'analise/liberacao-clausula/resumo',
        component: ResumoLiberacaoClausula,
        meta: {
          // Deve ser usado para casos de páginas do cadastro que não devem ser um das abas
          isResumo: true,
          routeGroup: 'liberacao-clausula'
        }
      }
    ]
  },
  {
    path: 'RELATORIO_CREDENCIADOS',
    name: 'RELATORIO_GRF_CAF_CREDENCIADOS',
    component: CaixaCredenciados,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'RELATORIO_GRF_CAF_CREDENCIADOS'
    }
  },
  {
    path: 'ASSINATURA_CONJUNTA',
    name: 'ASSINATURA_CONJUNTA',
    component: CaixaAssinaturasLaudoListagem,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'ASSINATURA_CONJUNTA'
    }
  },
  {
    path: 'CAIXA_SOBRESTADO',
    name: 'CAIXA_SOBRESTADO',
    component: CaixaSobrestado,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_SOBRESTADO'
    }
  },
  {
    path: 'CAIXA_RETIFICACAO',
    name: 'CAIXA_RETIFICACAO',
    component: CaixaRetificacao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_RETIFICACAO'
    }
  },
  {
    codigo: 'CONTINUAR_EMISSAO_EXTRATO_SENTENCA',
    path: '/continuar-emissao-extrato-sentenca/:idProcesso',
    name: 'continuar-emissao-extrato-sentenca',
    component: EmissaoExtratoSentenca,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EM_ANALISE'
    }
  },
  {
    path: 'CAIXA_CONFLITOS',
    name: 'CAIXA_CONFLITOS',
    component: GestaoConflito,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_CONFLITOS'
    }
  },
  {
    path: 'CAIXA_VISTORIA_REMOTA',
    name: 'CAIXA_VISTORIA_REMOTA',
    component: CaixaVistoriaRemota,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_VISTORIA_REMOTA'
    }
  },
  {
    path: 'conflito/validar/:id',
    name: 'conflito/validar',
    component: ValidarShapeConflito,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_CONFLITOS'
    }
  },
  {
    path: 'TITULOS_PARA_ENTREGA',
    name: 'TITULOS_PARA_ENTREGA',
    component: CaixaEntregaTitulo,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'TITULOS_PARA_ENTREGA'
    }
  },
  {
    path: 'CAIXA_EMISSAO_TITULO',
    name: 'CAIXA_EMISSAO_TITULO',
    component: CaixaEmissaoTitulo,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_EMISSAO_TITULO'
    }
  },
  {
    codigo: 'EMITIR_CERITDAO_AREA',
    path: '/emitir-certidao-area/:idProcesso/:acaoCaixa',
    name: 'EMITIR_CERITDAO_AREA',
    component: EmitirCertidaoArea,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EMITIR_CERITDAO_AREA'
    }
  },
  {
    codigo: 'CONTINUAR_EMISSAO_CERTIDAO_AREA',
    path: '/emitir-certidao-area/:idProcesso/:acaoCaixa',
    name: 'CONTINUAR_EMISSAO_CERTIDAO_AREA',
    component: EmitirCertidaoArea,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'EMITIR_CERITDAO_AREA'
    }
  },
  {
    path: 'CADASTROS_EM_ANDAMENTO_RF',
    name: 'CADASTROS_EM_ANDAMENTO_RF',
    component: CaixaCadastrosEmAndamentoListagemRf,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CADASTROS_EM_ANDAMENTO_RF'
    }
  },
  {
    codigo: 'CONTINUAR_CADASTRO_RF',
    path: 'cadastro-rf/:id?',
    name: 'cadastro-rf',
    component: CadastroRf,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CADASTROS_EM_ANDAMENTO_RF'
    }
  },
  {
    path: 'CADASTROS_EM_ANDAMENTO_UC',
    name: 'CADASTROS_EM_ANDAMENTO_UC',
    component: CaixaCadastrosEmAndamentoListagemUc,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CADASTROS_EM_ANDAMENTO_UC'
    }
  },
  {
    path: 'cadastro-uc/:id',
    name: 'cadastro-uc',
    component: AppCadastroUc,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CADASTROS_EM_ANDAMENTO_UC'
    }
  },
  {
    path: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO',
    name: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO',
    component: CaixaCadastrosPendentesGeo,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO'
    }
  },
  {
    codigo: 'GERAR_GEO_CADASTRO_PENDENTE',
    path: '/gerar-geo-cadastro-pendente/:idCadastroGeo?',
    name: '/gerar-geo-cadastro-pendente',
    component: GerarGeoCadastroPendente,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO'
    }
  },
  {
    codigo: 'BUSCAR_PROCESSOS',
    path: '/buscarProcessos',
    name: 'BUSCAR_PROCESSOS',
    component: CaixaBuscarProcessos,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'BUSCAR_PROCESSOS'
    }
  },
  {
    codigo: 'CAIXA_SOLICITAÇÕES',
    path: '/caixaSolicitacoes',
    name: 'CAIXA_SOLICITAÇÕES',
    component: CaixaSolicitacoes,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'CAIXA_SOLICITAÇÕES'
    }
  },
  {
    codigo: 'VIEW_PROCESSOS_SUSPENSOS',
    path: 'VIEW_PROCESSOS_SUSPENSOS',
    name: 'VIEW_PROCESSOS_SUSPENSOS',
    component: CaixaSuspensao,
    props: true,
    meta: {
      isPublic: false,
      routeGroup: 'VIEW_PROCESSOS_SUSPENSOS'
    }
  }
]

export const intervalTime = 60000



// WEBPACK FOOTER //
// ./src/screens/analise/config.js